import { observer } from 'mobx-react-lite';

import { Job } from '~hooks/useJob/models';
import { pendingJobStates } from '~pages/Dispatch/constants/jobStates';
import useDriverSchedulerFetch from '~pages/Dispatch/hooks/useDriverSchedulerFetch';
import { useStores } from '~store/RootStore';
import { getEffectiveUserCompanyId } from '~utils/user/user-utils';

import { ROW_HEIGHT } from './constants';
import InfiniteList from './InfiniteList';
import { JobCard, JobPlacement } from './JobCard';

export const UnassignedJobsList = observer(() => {
  const { fetchUnassignedJobs } = useDriverSchedulerFetch();
  const { userStore, driverSchedulerStore } = useStores();
  const companyId = getEffectiveUserCompanyId(userStore);

  const hasNextJobsPage = !!driverSchedulerStore.unassignedJobsPagination.after?.length;

  const loadMoreJobs = () => {
    if (!hasNextJobsPage) return;

    void Promise.resolve(
      fetchUnassignedJobs({
        states: pendingJobStates,
        companyId,
      }),
    ).catch(() => {
      // Error is handled by the hook.
    });
  };

  return (
    <InfiniteList<Job>
      items={driverSchedulerStore.unassignedJobs}
      itemCount={driverSchedulerStore.unassignedJobs.length}
      itemSize={ROW_HEIGHT}
      loadMoreItems={loadMoreJobs}
      hasNextPage={hasNextJobsPage}
      style={{ overflowX: 'hidden' }}
      renderItem={(index, style) => (
        <JobCard
          key={driverSchedulerStore.unassignedJobs[index]?.id}
          jobId={driverSchedulerStore.unassignedJobs[index]?.id}
          style={style}
          jobPlacement={JobPlacement.JOBS_COLUMN}
        />
      )}
    />
  );
});
